import { toast } from "react-hot-toast";

export default function ClipBoardData(data, toaster = "") {
  return navigator.clipboard.writeText(data).then(() => {
    toast.success(toaster + " copied successfully");
  });
}
